// src/components/PropertyFormSections/BasicDetails.js
import React from 'react';
import LocationPicker from '../LocationPicker';

const BasicDetails = ({ formData, handleInputChange, handleLocationSelect }) => {
    return (
        <>
            {/* Location */}
            <div className="mb-4">
                <label className="block font-bold">Location</label>
                <input
                    type="text"
                    name="location"
                    value={formData.location}
                    onChange={handleInputChange}
                    placeholder="Building Name e.g., Peninsula Business Park - Lower Parel"
                    className="border p-2 w-full"
                    required
                />
            </div>

            {/* Sub Locality */}
            <div className="mb-4">
                <label className="block font-bold">Sub Locality</label>
                <input
                    type="text"
                    name="sub_locality"
                    value={formData.sub_locality}
                    onChange={handleInputChange}
                    placeholder="e.g., Lower Parel"
                    className="border p-2 w-full"
                />
            </div>

            {/* Map Location */}
            <div className="mb-4">
                <label className="block font-bold">📍 Map Location</label>
                <LocationPicker 
                    onLocationSelect={handleLocationSelect}
                    initialPosition={[18.5204, 73.8567]}
                />
                <div className="grid grid-cols-2 gap-2 mt-2">
                    <input
                        type="text"
                        name="latitude"
                        value={formData.latitude || ''}
                        onChange={handleInputChange}
                        placeholder="Latitude"
                        className="border p-1 text-xs"
                    />
                    <input
                        type="text"
                        name="longitude"
                        value={formData.longitude || ''}
                        onChange={handleInputChange}
                        placeholder="Longitude"
                        className="border p-1 text-xs"
                    />
                </div>
            </div>

            {/* City */}
            <div className="mb-4">
                <label className="block font-bold">City</label>
                <select
                    name="city"
                    value={formData.city || 'mumbai'}
                    onChange={handleInputChange}
                    className="border p-2 w-full"
                >
                    <option value="mumbai">Mumbai</option>
                    <option value="pune">Pune</option>
                    <option value="delhi">Delhi</option>
                    <option value="bangalore">Bangalore</option>
                </select>
            </div>

            {/* Property Type */}
            <div className="mb-4">
                <label className="block font-bold">Property Type</label>
                <select
                    name="property_type"
                    value={formData.property_type}
                    onChange={handleInputChange}
                    className="border p-2 w-full"
                >
                    <optgroup label="Office">
                        <option value="Office Lease">Office Lease</option>
                        <option value="Office Sale">Office Sale</option>
                    </optgroup>
                    <optgroup label="Warehouse/Industrial">
                        <option value="Warehouse Rent">Warehouse Rent</option>
                        <option value="Warehouse Sale">Warehouse Sale</option>
                        <option value="Industrial Land">Industrial Land</option>
                        <option value="Factory">Factory</option>
                        <option value="Godown">Godown</option>
                        <option value="Cold Storage">Cold Storage</option>
                        <option value="Logistics Park">Logistics Park</option>
                    </optgroup>
                </select>
            </div>
        </>
    );
};

export default BasicDetails;